
<template>
    <ValidationObserver ref="personalInfoFormValidate">
        <h6>{{ $t('personal_info') }}</h6>
        <div class="border p-4 rounded-sm mb-3">
                 <b-row>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="national_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('national_id')">
                            <b-form-input v-model="formData.national_id" :disabled="true"  readonly :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="name"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="formData.name" :disabled="true" readonly :state="errors[0] ? false : null" />
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>

                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="surname"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="formData.surname" :disabled="true" readonly :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="gender"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('gender')">
                            <gender-selectbox v-model="formData.gender" :state="errors[0] ? false : null" />
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="birthdate"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('birthdate')">
                            <select-date v-model="formData.birthdate" :disabled="true" readonly  :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="personal_email"
                        rules="required|email"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('email')">
                            <b-form-input v-model="formData.personal_email" :state="errors[0] ? false : null" />
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="mobile_tel"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('gsm_no')">
                            <b-form-input v-mask="'### ### ## ##'" v-model="formData.mobile_tel" :disabled="true" readonly :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="job"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('job')">
                            <b-form-input v-model="formData.job" :state="errors[0] ? false : null" />
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider
                        name="education_status"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('education_status')">
                            <parameter-selectbox code="ulmer_application.education_statuses" :public="true" v-model="formData.education_status" :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <ValidationProvider
                        name="city_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('city')">
                            <city-selectbox v-model="formData.city_id" :state="errors[0] ? false : null" />
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="6">
                    <ValidationProvider
                        name="district_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('district')">
                            <district-outline-selectbox v-model="formData.district_id" :city_id="formData.city_id" :state="errors[0] ? false : null" />
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12" md="12" lg="12">
                    <ValidationProvider
                        name="address"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('address')">
                            <b-form-textarea  v-model="formData.address" rows="4" :state="errors[0] ? false : null"></b-form-textarea>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </div>

        <div class="d-flex justify-content-center mt-3">
            <ProcessingButton :label="$t('save')" :processing="loading" :disabled="loading" @click="save"/>
        </div>
    </ValidationObserver>
</template>
<script>
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox.vue";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import UlmerCertificatesApplicationsServices from "@/services/UlmerCertificatesApplicationsServices";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";

export default {
    name: "PersonalInformation",
    components: {ProcessingButton, CitySelectbox, DistrictOutlineSelectbox},
    data() {
        return {
            loading:false,
            formData: {
                national_id: null,
                name: null,
                surname: null,
                gender: null,
                birthdate: null,
                personal_email: null,
                mobile_tel: null,
                profession: null,
                education_status: null,
                city_id: null,
                district_id: null,
                address: null
            }
        }
    },
    mounted() {
        const isLogin =this.$store.getters['UlmerCertificatesApplication/isLogin'];
        if (!isLogin){
            return
        }
        this.formData=isLogin
    },
    methods:{
        async save(){
            const isValid =await  this.$refs.personalInfoFormValidate.validate()
            if (!isValid)return
            try {
                this.loading=true
                const res =await UlmerCertificatesApplicationsServices.savePersonalInformation(this.formData)
                this.$store.dispatch('UlmerCertificatesApplication/initData', res.data.data);
                this.$toast.success(this.$t('proccess_success'))
                this.$emit('goNextTab',1)
            }catch (err){
                this.showErrors(err,this.$refs.personalInfoFormValidate)
            }finally {
                this.loading=false
            }
        }
    }
}


</script>

<style scoped>

</style>
